import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import logo from '../assests/img/logo.svg';
import navIcon1 from '../assests/img/nav-icon1.svg';
import navIcon2 from '../assests/img/nav-icon2.svg';
import navIcon3 from '../assests/img/nav-icon3.svg';

export const Footer = () => {
  return (
    <footer className='footer'>
        <Container>
            <Row className='align-items-center'>
               
               <Col size={12} sm={6} >
               <img src={logo} alt='Logo' />
               </Col>
               <Col size={12} sm={6} className='text-center text-sm-end'>
               <div className='social-icon' style={{margin:"2px"}}>
                <a href='https://linkedin.com/in/touseef-zakria-0a4333314' target='_blank' ><img src={navIcon1} alt='icon'/></a>
                <a href='https://www.facebook.com/touseefsatti.satti.3?mibextid=ZbWKwL' target='_blank' ><img src={navIcon2} alt='icon'/></a>
                <a href='https://www.instagram.com/touseef__z3?igsh=OW11Mm9wOTloNmR5' target='_blank' ><img src={navIcon3} alt='icon'/></a>
               </div>
               <p>CopyRight <span>{new Date().getFullYear()}</span>. All Rights Reserved</p>
               
               </Col>
            </Row>
        </Container>

    </footer>
  )
}
